
  import {Component, Vue} from "vue-property-decorator";
  import KeyPressService from "@/Services/KeyPressService";
  import HotKeyService from "@/Services/HotKeyService";
  import {EventBus} from "@/Services/helpers/EventBus";

  @Component export default class HotKeyListener extends Vue {

    // registruojam hotKeyDetect metodą klavišų paspaudimams
    mounted() {
      window.addEventListener("keydown", this.hotKeyDetect);
    }

    destroyed() {
      window.removeEventListener("keydown", this.hotKeyDetect);
    }

    /**
     * emitinam eventą, jei paspaustas greitasis klavišas
     * eventų klauso komponentai, kurie atsako už reikalingų veiksmų įvykdymą
     *
     * @param {KeyboardEvent} e
     */
    hotKeyDetect = (e: KeyboardEvent) => {
      const keyPressService = new KeyPressService(e);
      const hotKeyService = new HotKeyService(keyPressService);
      if (hotKeyService.keyIsSupported()) {
        e.preventDefault();
        e.stopPropagation();
        const action = hotKeyService.hotKeyAction();
        EventBus.$emit(action);
      }
    }
  }
